const MAIN_CONTENT_ID = 'main-content';

const SkipToMainContent = () => {
  return (
    <a
      href={`#${MAIN_CONTENT_ID}`}
      className="sr-only fixed left-4 top-4 z-[100] rounded-md bg-surface-alt px-4 py-3 text-sm font-semibold text-surface-alt-90 shadow-2 focus:not-sr-only focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary"
    >
      Skip to main content
    </a>
  );
};

export { MAIN_CONTENT_ID };

export default SkipToMainContent;
